import * as React from "react";
import type { SVGProps } from "react";
const SvgMinimize2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 13a1 1 0 1 0 0 2zm6 1h1a1 1 0 0 0-1-1zm-1 6a1 1 0 1 0 2 0zm11-9a1 1 0 1 0 0-2zm-6-1h-1a1 1 0 0 0 1 1zm1-6a1 1 0 1 0-2 0zm6.707-.293a1 1 0 0 0-1.414-1.414zM2.293 20.293a1 1 0 1 0 1.414 1.414zM4 15h6v-2H4zm5-1v6h2v-6zm11-5h-6v2h6zm-5 1V4h-2v6zm-.293.707 7-7-1.414-1.414-7 7zm-11 11 7-7-1.414-1.414-7 7z"
    />
  </svg>
);
export default SvgMinimize2;
